// TUT-589 — o cadastro de fornecedores: quem presta serviço ou vende ao
// escritório. Mesmo molde das locadoras (`./frota`): lista paginada e
// ordenável, criar, corrigir e ativar/desativar — sem excluir, porque o
// fornecedor pago continua nas contas a pagar.
import { demoApi } from "../demo-data";
import type {
  CreateSupplierInput,
  Supplier,
  SupplierListResponse,
} from "../types";
import { comFatia, request } from "./infra";
import type { FatiaPedida } from "./infra";

// Lido aqui, e não importado: o empacotador só dobra a constante no módulo
// que a escreve, e é isso que tira o demo do build de produção (TUT-448).
const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

export const apiDosFornecedores = {
  suppliers(
    includeInactive = false,
    fatia: FatiaPedida = {},
    search = "",
  ): Promise<SupplierListResponse> {
    if (useDemoApi) return demoApi.suppliers(includeInactive, fatia, search);
    const params = new URLSearchParams();
    if (includeInactive) params.set("includeInactive", "true");
    if (search) params.set("search", search);
    return request<SupplierListResponse>(`/suppliers${comFatia(params, fatia)}`);
  },
  createSupplier(input: CreateSupplierInput): Promise<Supplier> {
    if (useDemoApi) return demoApi.createSupplier(input);
    return request<Supplier>("/suppliers", {
      method: "POST",
      body: JSON.stringify(input),
    });
  },
  updateSupplier(id: string, input: CreateSupplierInput): Promise<Supplier> {
    if (useDemoApi) return demoApi.updateSupplier(id, input);
    return request<Supplier>(`/suppliers/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: JSON.stringify(input),
    });
  },
  setSupplierActive(id: string, active: boolean): Promise<Supplier> {
    if (useDemoApi) return demoApi.setSupplierActive(id, active);
    return request<Supplier>(`/suppliers/${encodeURIComponent(id)}/active`, {
      method: "POST",
      body: JSON.stringify({ active }),
    });
  },
};
